<template>
  <div>
    {{ employeeDescription }}
  </div>
</template>

<script>
export default {
  name: 'EmployeeCellRenderer',
  data() {
    return {
      isContractual: null,
      employeeCode: null
    }
  },
  computed : {
    employeeDescription() {
      if (this.employeeCode === null) {
        return null;
      }
      else {
        const employee = this.params.context.componentParent.employees.find(e => e.code === this.employeeCode && e.isContractual === this.isContractual)
        if (employee) {
          let description = employee.fullName;
          if (employee.isContractual)
            description += "(C)";

          return description;
        }
        else {
          return null;
        }
      }
    }
  },
  created() {
    this.isContractual = this.params.value.isContractual;
    this.employeeCode = this.params.value.employeeCode;
 
  }
}
</script>
